import { render, staticRenderFns } from "./TrademarkSearchStatusList.vue?vue&type=template&id=0b77ede9&"
import script from "./TrademarkSearchStatusList.vue?vue&type=script&lang=js&"
export * from "./TrademarkSearchStatusList.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkSearchStatusList.vue?vue&type=style&index=0&id=0b77ede9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports